var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[(_vm.content === true)?_c('span',[_vm._v("IN")]):(_vm.content === false)?_c('span',[_vm._v("OUT")]):_c('span',[_vm._v("C2C")])])}
var staticRenderFns = []

export { render, staticRenderFns }